module.exports = __webpack_public_path__ + "static/media/logo_menu.72660944.svg";